import React from 'react';
import PropTypes from 'prop-types';

import {useLocation} from 'react-router-dom';

import {dispatch, connect} from 'utils/state_manager';

import {Box} from 'views/components';

import NavbarService from './NavbarService';

const NavbarServices = (props) => {
  const [expand, setExpand] = React.useState(false);

  const services = props.services;

  const location = useLocation();

  return (
    <Box
    >
      {
        Object.entries(services).map(([serviceName, e], index) => {
          return (
            <Box
              key={index}
              sx={{
                mb: 1,
                ml: 1,
              }}
            >
              <NavbarService
                serviceName={serviceName}
                selected={e.isActive(location.pathname)}
                title={e.title}
                link={e.link}
                options={Object.values(e.options)}
                expand={serviceName === expand}
                setExpand={setExpand}
              />
            </Box>
          );
        })
      }
    </Box>
  );
};
NavbarServices.propTypes = {
  services: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(NavbarServices));
